"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntellicaConflictError = void 0;
const BaseError_1 = require("./BaseError");
class EntellicaConflictError extends BaseError_1.BaseError {
    constructor(description = "Conflict") {
        super("EntellicaConflictError", 409, description, true);
    }
}
exports.EntellicaConflictError = EntellicaConflictError;
